import axios, { axiosCore, isCancel } from '../axios';

export const getCodeList = async (params, signal) => {
  try {
    const res = await axios.get('code/list/', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getCoding = async signal => {
  try {
    const res = await axios.get('code/coding/', { signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getCodeById = async (codeId, params, signal) => {
  try {
    const res = await axios.get(`code/profile_code/${codeId}/`, {
      params,
      signal,
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const lemmatize = async data => {
  try {
    const res = await axiosCore.post('hard_clean', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const checkReplacement = async data => {
  try {
    const res = await axiosCore.post('repl_clean', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const createWord = async data => {
  try {
    const res = await axios.post('word/create/', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const createCode = async data => {
  try {
    const res = await axios.post('code/create/', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getLanguages = async () => {
  try {
    const res = await axios.get('language/list');
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateCode = async (profileСodeId, data) => {
  try {
    const res = await axios.put(`code/profile_code/${profileСodeId}/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

// удаление кода из профиля
export const deleteProfileCode = async profileСodeId => {
  try {
    const res = await axios.delete(`code/profile_code/${profileСodeId}/`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const addCodeToProfile = async (codeId, data) => {
  try {
    const res = await axios.put(`code/${codeId}/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getBasicWords = async data => {
  try {
    const res = await axiosCore.post('basic_words', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const transferWords = async data => {
  try {
    const res = await axios.post('word/transfer/', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateWords = async (codeId, data) => {
  try {
    const res = await axios.patch(`word/${codeId}/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateWordSet = async (wordId, data) => {
  try {
    const res = await axios.put(`word/${wordId}/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const deleteWordSet = async id => {
  try {
    const res = await axios.delete(`word/${id}/`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getWordCodes = async (params, signal) => {
  try {
    const res = await axios.get('word/codes/', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const bulkUpdateWordSet = async data => {
  try {
    const res = await axios.post('word/bulk-update/', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

// словарь замен
export const getReplacements = async (params, signal) => {
  try {
    const res = await axios.get('replacements/list/', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateReplacement = async (replacementId, data) => {
  try {
    const res = await axios.patch(`replacements/${replacementId}/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const deleteReplacement = async replacementId => {
  try {
    const res = await axios.delete(`replacements/${replacementId}/`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const createReplacement = async params => {
  try {
    const res = await axios.post('replacements/create/', null, { params });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getReplacementTypes = async () => {
  try {
    const res = await axios.get('replacements/types/');
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const classify = async (data, params) => {
  try {
    const res = await axiosCore.post('classifier', data, { params });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const classifyFile = async data => {
  try {
    const res = await axiosCore.post('classify_file', data);

    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getReplacementType = async data => {
  try {
    const res = await axiosCore.post('typify_replacement', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const uploadFile = async data => {
  try {
    const res = await axiosCore.postForm('upload_file', data, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getProfiles = async () => {
  try {
    const res = await axios.get('profiles/list/');
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getRelatedCode = async (params, signal) => {
  try {
    const res = await axios.get('code/related/', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const removeLink = async id => {
  try {
    const res = await axios.delete(`code/related/${id}/`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateLink = async (id, languageId, data) => {
  try {
    const res = await axios.put(`code/related/${id}/`, data, {
      params: { language_id: languageId },
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const createLink = async data => {
  try {
    const res = await axios.post(`code/related/`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

// Matching

export const matchFile = async data => {
  try {
    const res = await axiosCore.post('match_file', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getFileResult = async taskId => {
  try {
    const res = await axiosCore.get(`file_result/${taskId}`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const matchText = async data => {
  try {
    const res = await axiosCore.post('match_gp_test', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

// скачать таблицы Excel
export const downloadCode = async data => {
  try {
    const res = await axios.get('code/download/', {
      responseType: 'blob',
      params: data,
    });

    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const downloadRelatedCode = async data => {
  try {
    const res = await axios.get('code/related/download/', {
      responseType: 'blob',
      params: data,
    });

    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const downloadReplacementsCode = async data => {
  try {
    const res = await axios.get('replacements/download/', {
      responseType: 'blob',
      params: data,
    });

    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const downloadWordCodes = async data => {
  try {
    const res = await axios.get('word/download/', {
      responseType: 'blob',
      params: data,
    });

    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};
